import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observe, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as moment from 'moment-timezone';
import * as React from 'react';
import { Link, Prompt, withRouter } from 'react-router-dom';
import { Badge, Button, Col, Form, FormGroup, Label, Row } from 'reactstrap';
import { EInput } from 'src/Components/EInput';
import PdfService from 'src/Services/Pdf';
import { ITest, IWellStory } from '../../../../../Interfaces/TestInterface';
import { IWell } from '../../../../../Interfaces/WellInterface';
import Footer from '../../../../Footer';
import WorkflowHeader from '../../../WorkflowHeader';

@inject('stores')
@observer
class RemarksA extends React.Component {
    public props: any;
    private test: ITest = new ITest();
    public TestsStore: any;
    private testDisposer: any;
    private well: IWell = new IWell();
    public WellsStore: any;
    private wellDisposer: any;

    public state = {
        isDirty: false,
        saveClicked: false,
        test: this.test,
        well: this.well
    };

    constructor(props: any) {
        super(props);

        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;

        this.handleInputChange = this.handleInputChange.bind(this);
        this.addTourlyWellStory = this.addTourlyWellStory.bind(this);
        this.addChangeWellStory = this.addChangeWellStory.bind(this);
        this.copyPreviousTourlyTreatment = this.copyPreviousTourlyTreatment.bind(this);


        this.clearDisposers = this.clearDisposers.bind(this);
    }

    public componentDidMount() {
        if ( this.props.stores.WellsStore.well && this.props.stores.TestsStore.test ) {
            this.setState({
                test: toJS(this.props.stores.TestsStore.test),
                well: toJS(this.props.stores.WellsStore.well)
            });
        } else {
            if ( ! this.TestsStore.test ) {
                this.TestsStore.getTestDetails(this.props.match.params.taskId, this.props.match.params.wellId);
            }
            if ( ! this.WellsStore.well ) {
                this.WellsStore.getWellDetails(this.props.match.params.wellId);
            }
        }
        this.createDisposers();
    }

    public createDisposers() {
        this.testDisposer = observe(this.TestsStore, 'test', (change: any) => {
            const test = toJS(change.newValue);
            this.setState({
                test
            });
        });
        this.wellDisposer = observe(this.WellsStore, 'well', (change: any) => {
            const well = toJS(change.newValue);
            this.setState({
                well
            });
        });
    }

    public async componentWillUnmount() {
        this.clearDisposers();
    }

    public clearDisposers() {
        if ( this.testDisposer ) {
            this.testDisposer();
        }
        if ( this.wellDisposer ) {
            this.wellDisposer();
        }
    }

    private handleInputChange(event: any) {
        const test = this.state.test;
        test.remarks[event.target.name] = event.target.value;
        this.setState({
            isDirty: true,
            test
        });
    }

    private addTourlyWellStory() {
        const test = this.state.test;
        const wellStories = test.remarks.wellStories;
        const wellStory = new IWellStory();
        wellStory.remarkText = this.state.test.remarks.tourlyTreatment;
        wellStory.remarkSubType = "Tourly Treatment";
        wellStory.remarkSubmittedDate = moment().unix().toString();
        wellStories.unshift(wellStory);
        test.remarks.wellStories = wellStories;
        this.setState({
            isDirty: true,
            test
        });
    }

    private addChangeWellStory() {
        const test = this.state.test;
        const wellStories = test.remarks.wellStories;
        const wellStory = new IWellStory();
        wellStory.remarkText = this.state.test.remarks.tourlyTreatmentChanges;
        wellStory.remarkSubType = "Tourly Treatment Changes";
        wellStory.remarkSubmittedDate = moment().unix().toString();
        wellStories.unshift(wellStory);
        test.remarks.wellStories = wellStories;
        this.setState({
            isDirty: true,
            test
        });
    }

    private handleWellStoryDelete = (index: number) => (event: React.MouseEvent<HTMLDivElement>) => {
        const test = this.state.test;
        const wellStories = test.remarks.wellStories;
        wellStories.splice(index, 1);
        this.setState({
            isDirty: true,
            test
        });
    }

    private copyPreviousTourlyTreatment() {
        const test = this.state.test;
        test.remarks.tourlyTreatment = test.remarks.previousTourlyTreatment;
        this.setState({
            isDirty: true,
            test
        });
    }

    private updateTestModel = () => {
        this.TestsStore.updateTestModel(this.state.test, this.props.match.params.wellId).then((test:any) => {
            if (test) {
                this.setState({
                    isDirty: false,
                });
            }
        });
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;
        if ( $target.name === 'previous' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/fluiddata/solidscontrol');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/fluiddata/remarks');
        }
    }

    private tourlyTooLong() {
        return PdfService.isTooBigForTourly(this.state.test);
    }

    public render() {
        return(
            <div className="RemarksA">
            <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} isInventoryReport={this.state.test.isInventoryReport}/>
                <Row>
                    <Col md="5">
                        <h4>Well Story</h4>
                        <div id="well-story" className="well-story">
                            { this.state.test.remarks.wellStories &&
                                this.state.test.remarks.wellStories.map((story: IWellStory, index: number) =>
                                    <div key={index}>
                                        {story.remarkText.split('\n').map((remark, indexRem) => {
                                            if(remark === '') {
                                                return <br key={indexRem} />;
                                            }
                                            return <p key={indexRem} className="the-remark">{remark}</p>;
                                        })
                                        }
                                        <p className="remark-datetime">
                                            {story.remarkSubType + ' | ' + moment(story.remarkSubmittedDate, 'X').format('LLL')}
                                            {
                                                (story.createdWellTestId === '' || story.createdWellTestId === this.state.test.id)
                                                && this.state.test.testStatus !== 'Approved'
                                                &&
                                                <span onClick={this.handleWellStoryDelete(index)}>
                                                    {' | '}<FontAwesomeIcon icon={faTrashAlt} />
                                                </span>
                                            }
                                        </p>
                                    </div>
                            ) }
                        </div>
                        {
                            this.state.test.remarks.wellStories.length === 0 ?
                            <Button color="primary" disabled={true}>Print Well Story</Button>
                            :
                            <Link className='btn btn-primary' to={`/print/well/${this.state.well.id}/test/${this.state.test.id}/wellstorypdf`} target="_blank">Print Well Story</Link>
                        }
                    </Col>
                    <Col md="7">
                        <Form>
                            <h4>Tour Treatment</h4>
                            <FormGroup>
                                <Label>Previous Tourly Treatment Remarks</Label>
                                <EInput
                                    type="textarea"
                                    rows="6"
                                    name="previousTourlyTreatment"
                                    id="previousTourlyTreatment"
                                    value={this.state.test.remarks.previousTourlyTreatment}
                                    disabled={true}
                                />
                                <Button color="primary" onClick={this.copyPreviousTourlyTreatment}>Copy Previous Tourly Treatment to Current</Button>
                            </FormGroup>
                            <FormGroup className="required">
                            <Label>Current Tourly Treatment Remarks</Label>
                                <EInput
                                    rows="6"
                                    type="textarea"
                                    name="tourlyTreatment"
                                    id="tourlyTreatment"
                                    required={true}
                                    value={this.state.test.remarks.tourlyTreatment}
                                    onChange={this.handleInputChange}
                                />
                                { this.tourlyTooLong() && <h5 style={{marginBottom: 0}}><Badge color="danger">Not all remarks will display on the Mud Report</Badge></h5>}
                                <Button color="primary" onClick={this.addTourlyWellStory} disabled={this.state.test.remarks.tourlyTreatment === '' ? true : false}>Add to Well Story</Button>
                            </FormGroup>
                            <FormGroup>
                                <Label>Reasons for Changes to Tourly Treatment</Label>
                                <EInput
                                    rows="6"
                                    type="textarea"
                                    name="tourlyTreatmentChanges"
                                    id="tourlyTreatmentChanges"
                                    value={this.state.test.remarks.tourlyTreatmentChanges}
                                    onChange={this.handleInputChange}
                                />
                                <Button color="primary" onClick={this.addChangeWellStory} disabled={this.state.test.remarks.tourlyTreatmentChanges === '' ? true : false}>Add to Well Story</Button>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
                <Footer well={this.WellsStore.well} test={this.TestsStore.test} onSave={this.updateTestModel} onNavigate={this.buttonNavigation} />
            </div>
        );
    }

}

export default withRouter(RemarksA);



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/FluidData/RemarksA/RemarksA.tsx